$('div[popoverButton]').click(function () {
    var id = $(this).attr('popoverButton');
    if ($('.popup--content[popoverContent="' + id + '"]').is(':visible')) {
        $('.popup--content[popoverContent="' + id + '"]').fadeOut();
        $(this).removeClass('active');
    } else {
        $('.popup--content[popoverContent="' + id + '"]').fadeIn();
        $('.popup--content:not([popoverContent="' + id + '"])').fadeOut();
        $(this).addClass('active');
    }

    $(document).mouseup(function (e) {
        var container = $('.popup--content');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.popup--content').fadeOut();
            $('div[popoverButton]').removeClass('active');
        }
    });
});

// copy current url to clipboard (blog single)
function copyLink() {
    var copyText = window.location.href;
    navigator.clipboard.writeText(copyText);
}
$('.copy--link').click(function (e) {
    e.preventDefault();
    copyLink();
    return false;
});
